import { render, staticRenderFns } from "./OpenMemoir.vue?vue&type=template&id=1449d64e&"
import script from "./OpenMemoir.vue?vue&type=script&lang=js&"
export * from "./OpenMemoir.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports